import React from 'react';

import { flameTheme } from '@lightspeed/flame/Core';
import { IconClockOutline } from '@lightspeed/flame/Icon/ClockOutline';

import { BackbookExpiryBadge } from '../styles';

type Props = {
  daysUntilExpiry: number;
};

// Plain English phrases so Localize can translate them; the day count is the only
// dynamic value, wrapped so the translation system leaves it untouched.
const getExpiryText = (days: number): React.ReactNode => {
  if (days <= 1) return 'Last day';
  return (
    <span>
      <var className="notranslate">{days}</var> days left
    </span>
  );
};

/**
 * Orange expiry badge with a clock icon. Shows "{n} days left" while more than one
 * day remains, and "Last day" on the final day / day of expiry.
 */
export const ExpiryBadge: React.FC<Props> = ({ daysUntilExpiry }) => (
  <BackbookExpiryBadge data-test="backbook-expiry-badge">
    <IconClockOutline color={flameTheme.colors.textHeading} />
    {getExpiryText(daysUntilExpiry)}
  </BackbookExpiryBadge>
);
